import React from 'react'
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next'

import PropTypes from 'prop-types'
import { Transition, TransitionGroup } from 'react-transition-group'
import { gsap, ScrollSmoother, ScrollTrigger } from 'gsap-wrapper'
import ThemeProvider from 'styles/theme-provider'
import CookiesBanner from 'components/ui-elements/cookies-banner'
import { getLocalizedPath } from 'utils/i18n'

import 'styles/fonts.css'
import GlobalStyle from 'styles/global-styles'
import { LayoutWrapper, PageWrapper, ContentWrapper } from './index.styled'
import useWindowSize from 'styles/window-size'

const LayoutContent = ({ children, location }) => {
  return (
    <TransitionGroup component={null}>
      <Transition key={location.pathname} timeout={{ enter: 1000, exit: 1000 }}>
        {(status) => (
          <div className={`page ${status}`}>
            <LayoutWrapper>{children}</LayoutWrapper>
          </div>
        )}
      </Transition>
    </TransitionGroup>
  )
}

const Layout = (props) => {
  const { t } = useTranslation()
  const { language, generateDefaultLanguagePage } = useI18next()

  const { children, location } = props
  const refWrapper = React.useRef(null)
  const scrollSmoother = React.useRef(null)
  const { width } = useWindowSize()

  React.useLayoutEffect(() => {
    const gsapContext = gsap.context(() => {
      scrollSmoother.current = ScrollSmoother.create({
        content: '.home-content',
        wrapper: '.home-wrapper',
        smooth: 2,
        effects: true
      })

      const timeout = setTimeout(() => {
        if (width < 768) {
          scrollSmoother.current.scrollTop(0)
        }
        gsap.utils.toArray('.fadeIn').forEach(function (container) {
          ScrollTrigger.create({
            trigger: container,
            start: 'top 95%',
            end: '+=1000%',
            toggleClass: {
              targets: container,
              className: 'visible',
              toggle: 'add'
            },
            once: true
          })
        })
      }, 100)
      return () => clearTimeout(timeout)
    }, [refWrapper])

    return () => gsapContext.revert()
  }, [children, width])

  return (
    <ThemeProvider location={location} scrollSmoother={scrollSmoother}>
      <div className='home-wrapper' ref={refWrapper}>
        <div className='home-content'>
          <PageWrapper>
            <GlobalStyle />
            <ContentWrapper>
              <LayoutContent location={location}>{children}</LayoutContent>
            </ContentWrapper>
          </PageWrapper>
        </div>
        <CookiesBanner
          buttonText={t('Accept All')}
          desktopText={t('We use cookies to improve your experience. By using this website you agree to our')}
          desktopLinkText={t('Cookie Policy')}
          mobileText={t('This website uses')}
          mobileLinkText={t('cookies')}
          link={getLocalizedPath('/legal', language, generateDefaultLanguagePage)}
        />
      </div>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired
}

export default Layout
